// extracted by mini-css-extract-plugin
export default {"aboutJumbotron":"AboutPage_aboutJumbotron__pF-cz","mb-4":"AboutPage_mb-4__2Uk6I"};